
@if (collapse) {
    <mat-icon [ngx-tooltip]="itemsTooltip" [ngx-tooltip-config]="{ position: 'bottom', triggers: ['click'], stayOpen: true }">menu</mat-icon>

    <ng-template #itemsTooltip>
        <ng-container [ngTemplateOutlet]="icons" [ngTemplateOutletContext]="{ '$implicit': true }"/>
    </ng-template>
}
@else {
    <ng-container [ngTemplateOutlet]="icons" [ngTemplateOutletContext]="{}"/>
}

<ng-template #icons let-data>
    <div
        [class.floating-menu]="data"
    >
        <!-- Header -->
        <mat-icon [ngx-menu]="textSizeMenu" [class.reflect]="cursorIsInHeading" matTooltip="Headings">format_size</mat-icon>
        <!-- Color -->
        <mat-icon [ngx-tooltip]="colorPopup" [ngx-tooltip-config]="{ triggers: ['click'], position: 'bottom' }">
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" style="margin-top: -3px;">
                <path [style.fill]="currentTextColor" d="M2 20L2 24L22 24L22 20L2 20z" />
                <path fill="var(--text-color)" d="M10.75 3L5.49 17L7.91 17L9.18 13.42L14.83 13.42L16.09 17L18.51 17L13.25 3L10.75 3z M11.94 5.6L12.06 5.6L14.09 11.39L9.91 11.39L11.94 5.6z" />
            </svg>
        </mat-icon>

        <!-- Bold -->
        <mat-icon
            (mousedown)="actions.boldText(); $event.preventDefault()"
            [class.reflect]="cursorIsInBold"
            matTooltip="Bold"
        >
            format_bold
        </mat-icon>
        <!-- Italic -->
        <mat-icon
            (mousedown)="actions.italicizeText(); $event.preventDefault()"
            [class.reflect]="cursorIsInItalic"
            matTooltip="Italic"
        >
            format_italic
        </mat-icon>
        <!-- Strikethrough -->
        <mat-icon
            (mousedown)="actions.strikethroughText(); $event.preventDefault()"
            [class.reflect]="cursorIsInStrikethrough"
            matTooltip="Strikethrough"
        >
            format_strikethrough
        </mat-icon>
        <!-- Underscore -->
        <!-- <mat-icon>format_underlined</mat-icon> -->

        <!-- Quote -->
        <mat-icon
            (mousedown)="actions.blockQuoteText(); $event.preventDefault()"
            [class.reflect]="cursorIsInBlockquote"
            matTooltip="Blockquote"
        >
            format_quote
        </mat-icon>
        <!-- Link -->
        <mat-icon
            matTooltip="Insert a Link"
            [class.reflect]="cursorIsInLink"
            (mousedown)="actions.openLinkDialog(); $event.preventDefault()"
        >
            link
        </mat-icon>

        <!-- Ordered list -->
        <mat-icon (mousedown)="actions.insertOrderedList(); $event.preventDefault()" [class.reflect]="cursorIsInOrderedList" matTooltip="Ordered List">format_list_numbered</mat-icon>
        <!-- Unordered list -->
        <mat-icon (mousedown)="actions.insertList(); $event.preventDefault()" [class.reflect]="cursorIsInList" matTooltip="Unordered list">format_list_bulleted</mat-icon>
        <!-- Checklist -->
        <mat-icon (mousedown)="actions.insertCheckList(); $event.preventDefault()" [class.reflect]="cursorIsInChecklist" matTooltip="Checklist">rule</mat-icon>

        <!-- Table -->
        <mat-icon [ngx-tooltip]="tablePopup" [ngx-tooltip-config]="{ triggers: ['click'], position: 'bottom' }" [class.reflect]="cursorIsInTable">table_chart</mat-icon>
        <ng-template #tablePopup let-data="data" let-dialog="dialog">
            @for (ctx of [{cols: 0, rows: 0}]; track ctx) {
                <div

                    class="table-popup"
                >
                    <div>{{ctx.cols}}x{{ctx.rows}}</div>
                    <div class="grouped">
                        @for (row of [1,2,3,4,5,6]; track row) {
                            <div class="table-row">
                                @for (col of [1,2,3,4,5,6]; track col) {
                                    <div

                                        class="col-cell"
                                        [class.selected]="ctx.cols >= col && ctx.rows >= row"
                                        (pointerenter)="ctx.cols = col; ctx.rows = row"
                                        (click)="actions.insertTable(ctx.cols, ctx.rows); dialog.close()"
                                    ></div>
                                }
                            </div>
                        }
                    </div>
                </div>
            }
        </ng-template>

        <!-- Image -->
        <mat-icon
            matTooltip="Insert an image"
            (mousedown)="actions.openImageDialog(); $event.preventDefault()"
        >
            add_photo_alternate
        </mat-icon>


        <!-- Inline code -->
        <mat-icon
            (mousedown)="actions.insertInlineCode(); $event.preventDefault()"
            [class.reflect]="cursorIsInInlineCode"
            matTooltip="Inline highlight"
        >
            code
        </mat-icon>
        <!-- Code Block -->
        <mat-icon
            (mousedown)="actions.insertCodeBlock(); $event.preventDefault()"
            [class.reflect]="cursorIsInCode"
            matTooltip="Code block"
        >
            data_object
        </mat-icon>

        <!-- Mermaid Diagrams... -->
        @if (stackEditor.showMermaid) {
            <mat-icon
                [ngx-menu]="diagramMenu"
                [ngx-menu-config]="{
                    customClass: ['mermaid-menu']
                }"
                matTooltip="Diagrams"
            >
                account_tree
            </mat-icon>
        }
    </div>
</ng-template>


<!-- Horizontal spacer. -->
<span style="flex: 1">
    <!-- {{stackEditor.editorSvc?.focus}}
    //
    {{stackEditor.editorSvc?.clEditor?.selectionMgr?.selectionStart}}::
    {{stackEditor.editorSvc?.clEditor?.selectionMgr?.selectionEnd}} -->
</span>


@if (stackEditor.showToc != 'off') {
    <mat-icon

        (mousedown)="toggleTOC(); $event.preventDefault()"
        [matTooltip]="stackEditor.showToc ? 'Close Table of Contents' : 'Open Table of Contents'"
    >
        toc
    </mat-icon>
}

@if (stackEditor.showPreview != 'off' && stackEditor.mode != 'viewonly') {
    <mat-icon
        (mousedown)="toggleEditor(); $event.preventDefault()"
        matTooltip="Close Editor"
    >
        check
    </mat-icon>
}

@if (stackEditor.showPreview != 'off') {
    <mat-icon
        (mousedown)="togglePreview(); $event.preventDefault()"
        [matTooltip]="stackEditor.showPreview ? 'Hide Preview': 'Open Preview'"
    >
        visibility_off
    </mat-icon>
}

<ng-template #colorPopup let-dialog="dialog">
    @for (ctx of [{color: '#000'}]; track ctx) {
        <div
            class="table-popup"
        >
            <div
                [style.color]="ctx.color"
                [style.background-color]=""
            >
                {{ctx.color}}
            </div>
            <div class="grouped" style="display: flex; gap: 2px; flex-direction: column;">
                @for (row of colorList; track row) {
                    <div class="table-row">
                        @for (color of row; track color) {
                            <div

                                class="col-cell"
                                style="width: 24px; height: 24px"
                                [style.background-color]="color + 'ee'"
                                [style.border-color]="color + ''"
                                (click)="actions.colorizeText(currentTextColor = color); dialog.close()"
                                (pointerenter)="ctx.color = color"
                            >
                            </div>
                        }
                    </div>
                }
            </div>
        </div>
    }
</ng-template>
